import React from 'react'
import Draggable from "../../../DnD/Draggable";
import InputWrapper from "../../../../../components/Input/InputWrapper";

function Date() {
    return (
        <Draggable id="input-date">
            <InputWrapper>
                Date
                <div className="date">
                    mm/dd/yyyy
                </div>
            </InputWrapper>
        </Draggable>
    )
}

export default Date
